import { RouteType } from "types/RouteType";
// import designValuesRoute from "./DesignValues/designValues.Route";
import qualityControlRoute from "./QualityControl/qualityControl.Route";
// import qualityControlOverviewRoute from "./QualityControlOverview/qualityControlOverview.Route";

const qualityControlRoutesList: RouteType[] = [
    // ...designValuesRoute,
    qualityControlRoute,
    // ...qualityControlOverviewRoute,
];

export default qualityControlRoutesList;
